import React from 'react';
import { HOME_THEME as T, ACCENT_HEX, ACCENT_SOFT, type JuniorMenuItem } from '../../lib/juniorTheme';
import { useJuniorAliveNav } from '../../contexts/JuniorAliveNavContext';

interface JuniorMenuCardsProps {
  items: JuniorMenuItem[];
  animateEntry?: boolean;
}

export const JuniorMenuCards: React.FC<JuniorMenuCardsProps> = ({ items, animateEntry = false }) => {
  const { navigateAlive } = useJuniorAliveNav();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
      {items.map((item, i) => {
        const hex = ACCENT_HEX[item.accent];
        const soft = ACCENT_SOFT[item.accent];
        return (
          <button
            key={item.id}
            type="button"
            onClick={() => navigateAlive(item.path)}
            className={`junior-card-hover group relative flex flex-col gap-4 overflow-hidden rounded-[2rem] p-7 sm:p-8 text-left min-h-[260px] sm:min-h-[280px] ${
              animateEntry ? 'junior-alive-card' : ''
            }`}
            style={{
              animationDelay: animateEntry ? `${0.08 + i * 0.07}s` : undefined,
              background: 'rgba(255,255,255,0.9)',
              border: `3px solid ${hex}30`,
              boxShadow: `0 16px 40px -14px ${hex}50`,
            }}
          >
            <div
              className="absolute -right-10 -top-10 h-36 w-36 rounded-full opacity-35 blur-2xl"
              style={{ background: hex }}
              aria-hidden
            />

            <div className="relative z-10 flex items-start justify-between">
              <span
                className="junior-float text-6xl sm:text-7xl"
                style={{ animationDelay: `${i * 0.4}s` }}
                aria-hidden
              >
                {item.emoji}
              </span>
              <span
                className="text-2xl font-light transition-transform group-hover:translate-x-1"
                style={{ color: hex }}
                aria-hidden
              >
                →
              </span>
            </div>

            <div className="relative z-10 mt-auto">
              <p className="text-[10px] font-extrabold uppercase tracking-[0.2em]" style={{ color: `${hex}99` }}>
                {item.subtitle}
              </p>
              <h2 className="junior-display text-[clamp(2rem,5vw,2.75rem)] leading-none mt-1" style={{ color: T.text }}>
                {item.title}
              </h2>
              <p className="text-sm sm:text-base mt-3 leading-relaxed font-semibold" style={{ color: T.muted }}>
                {item.description}
              </p>
              <div
                className="inline-block mt-4 px-3 py-1 rounded-full text-[10px] font-extrabold uppercase tracking-wider"
                style={{ background: soft, color: hex }}
              >
                Explorar
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default JuniorMenuCards;
